var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8428 13.0387C18.4236 13.0387 19.748 14.3625 19.748 15.9371C19.748 17.5118 18.4237 18.8356 16.8428 18.8356C15.2618 18.8356 13.9375 17.5118 13.9375 15.9371C13.9376 14.3625 15.2619 13.0387 16.8428 13.0387Z",
    stroke: "#005FC8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1152 10.7275H39.1191V2.74609L47.1152 10.7275Z",
    stroke: "#005FC8",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.483 60.9375H43.9402C46.7186 60.9375 48.9298 58.7422 48.9298 55.9842V11.4625L38.4407 0.9375H6.69009V46.8103C6.69009 46.8103 7.03381 50.216 3.64315 50.216H-1.875",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1855 12.2887H31.0588",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1855 19.5859H42.4315",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 26.8832H42.4303",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 34.9912H42.4303",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 42.2883H42.4303",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 49.5863H42.4303",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8428 19.5859C14.8489 19.5859 13.1875 17.9275 13.1875 15.9373C13.1875 13.9471 14.8489 12.2887 16.8428 12.2887C18.8366 12.2887 20.498 13.9471 20.498 15.9373C20.498 17.9275 18.8366 19.5859 16.8428 19.5859Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3691 0.9375L48.9287 11.4778H38.3691V0.9375Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.793 13.9923L16.7943 13.4454",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7832 18.3742L16.7845 17.828",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5936 15.1204L17.5956 14.399C17.5923 14.1588 17.4427 13.9949 17.2267 13.9942L16.371 13.9902C16.0359 13.9889 15.9103 14.123 15.9156 14.4959L15.9196 15.0773C15.9216 15.2306 15.9841 15.3566 16.0905 15.4257L17.4062 16.2771C17.5132 16.3461 17.575 16.4729 17.577 16.6255L17.583 17.2818C17.5883 17.6548 17.5199 17.8313 17.1848 17.8293L16.2733 17.8253C16.0572 17.8246 15.9083 17.6607 15.9043 17.4205V16.7622",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.0f7344f5.svg";
export { ForwardRef as ReactComponent };